import EcranInstructions from "@/modules/autres/EcranInstructions";
import { useState, useEffect, useRef, useCallback } from "react";
import { useFullscreen } from "@mantine/hooks";
import { useLocation, useParams } from "react-router-dom";
import { LectureBilan } from "./Lecture";
import { toast } from "react-toastify";
import EcranInstructionsPreset from "../autres/EcranInscructionsPreset";

export const LauncherLecture = ({ TextNumber, onModuleEnd, saveFieldSession }: { TextNumber: number, onModuleEnd: ()=> void, saveFieldSession: (fieldsToUpdate: { field: string; value: string | number | number[] | Date; }[]) => void }) => {

  const [moduleActif, setModuleActif] = useState(false);
  const { toggle } = useFullscreen();
  const isPausedAndNotFullScreenRef = useRef<boolean>(!document.fullscreenElement); // Initialize with the current fullscreen state
  const [isPaused, setIsPaused] = useState(true);

  const [startTime, setStartTime] = useState<number | null>(null); // To track when text appears
  const [endTime, setEndTime] = useState<number | null>(null); // To track when reading finishes
  const [readingTime, setReadingTime] = useState<number | null>(null); // Reading time in seconds

  const lancerModule = useCallback(() => {
    setModuleActif(true);
    setIsPaused(false);
    setStartTime(Date.now()); // Record the start time when the module is launched
    // toggle();
  }, []);

  const { patientId } = useParams();
  const location = useLocation();
  const sessionForm = location.state;

  const caseSize = localStorage.getItem("selectedCaseSizePx");

  useEffect(() => {
    const handleFullscreenChange = () => {
      isPausedAndNotFullScreenRef.current = !document.fullscreenElement;
    };

    const handleKeyPress = async (event: { key: string }) => {
      if ((event.key === "p" || event.key === "Escape") && !isPaused) {
        toggle();
        isPausedAndNotFullScreenRef.current = !isPausedAndNotFullScreenRef.current;
      } else if (event.key === " ") {
        if (moduleActif && !isPausedAndNotFullScreenRef.current) {
          setIsPaused(true);
          const endTimeValue = Date.now(); // Capture the end time value
          setEndTime(endTimeValue); // Set the end time
          setReadingTime((endTimeValue - (startTime || 0)) / 1000); // Calculate reading time in seconds
  

          const fieldsToUpdate = [
            { field: "sessionDate", value: new Date() },
            { field: "status", value: "EN_COURS" },
            { field: "resultsBilanLecture", value: JSON.stringify((endTimeValue - (startTime || 0)) / 1000) }, // Save the reading time
          ];
          saveFieldSession(fieldsToUpdate);
          toast.success("Les résultats ont bien été enregistrés");
          onModuleEnd();
        }
      }
    };

    window.addEventListener("fullscreenchange", handleFullscreenChange);
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [moduleActif, isPausedAndNotFullScreenRef, toggle, isPaused, patientId, sessionForm, lancerModule]);

  useEffect(() => {
    if (startTime && endTime) {
      setReadingTime((endTime - startTime) / 1000); // Calculate reading time in seconds
    }
  }, [endTime]);

  if(!caseSize || caseSize === "undefined" || caseSize === "null" || caseSize === null || Number(caseSize) === 0) {
    return (
      <EcranInstructions instructions="Veuillez sélectionner une taille de case dans les paramètres avant de commencer le test." />
    );
  }

  return (
    <div>
      {!moduleActif ? (
             <EcranInstructionsPreset
             options={{
               dynamicDisplay: true,
               fontSizeMultiplier: 1.5,
               textColor: "white",
             }}
               preset={
                 "bilan-lecture"
               }
               setShowInstructions={lancerModule}
             />      ) : (
        <LectureBilan caseSize={Number(caseSize)} TextNumber={TextNumber} />
      )}
      {readingTime && <p>Temps de lecture : {readingTime} secondes</p>} {/* Display reading time */}
    </div>
  );
};
